import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { AppLayoutComponent } from './app-layout.component';
import { HeaderComponent } from './header/header.component';
import { NavigationComponent } from './navigation/navigation.component';
import { RouterModule, Routes } from '@angular/router';
import { UiModule } from '../ui/ui.module';
import { ModalConfirmActionComponent } from './modal-confirm-action/modal-confirm-action.component';
import { NgbDropdownModule, NgbModule, NgbToastModule } from '@ng-bootstrap/ng-bootstrap';
import { SearchAutocompleteComponent } from './header/search-autocomplete/search-autocomplete.component';
import { SectionNamePipe } from '../ui/directives/section.pipe';
import { TranslateModule } from '@ngx-translate/core';
import { ModalErrorComponent } from './modal-error/modal-error.component';
import { ToastComponent } from './toast/toast.component';
import { InlineSVGModule } from 'ng-inline-svg-2';

const routes: Routes = [
  {
    path: '',
    component: AppLayoutComponent
  }
];

@NgModule({
    declarations: [
      AppLayoutComponent, 
      HeaderComponent, 
      NavigationComponent, 
      ModalErrorComponent,
      ToastComponent,
      ModalConfirmActionComponent,
      SearchAutocompleteComponent,
      SectionNamePipe
    ],
    imports: [
        CommonModule,
        RouterModule.forChild(routes),
        TranslateModule,
        UiModule,
        NgbDropdownModule,
        NgbModule,
        NgbToastModule,
        InlineSVGModule.forRoot()
    ],
    exports:[
      ToastComponent,
      ModalErrorComponent
    ],
    providers: [
      DatePipe
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class AppLayoutModule { }
